<template>
    <div
        class="flex h-full w-full flex-col items-center justify-center gap-1.5 border-hairline border-dashed border-stack-primary px-2 text-center"
    >
        <ImagePlaceholderIcon
            class="h-6 w-6 flex-shrink-0 text-stack-primary opacity-70"
        />
        <span
            class="max-w-90pct truncate text-2.75 font-medium leading-tight text-stack-primary"
        >
            {{ label }}
        </span>
    </div>
</template>

<script>
import ImagePlaceholderIcon from "@/components/icons/ImagePlaceholderIcon.vue";

export default {
    name: "ProductPlaceholderImage",
    components: { ImagePlaceholderIcon },
    props: { label: { type: String, required: true } }
};
</script>
